import moment from "moment";

export function transformSalesData(inputData) {
  const monthAbbreviations = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract the year from the first available data entry, default to "2024" if none found
  const yearFromData =
    inputData.length > 0 ? inputData[0].timePeriod.split("-")[0] : "";

  const shortYear = yearFromData.slice(-2);

  return monthAbbreviations.map((abbr, index) => {
    const monthNumber = (index + 1).toString().padStart(2, "0"); // "01", "02", etc.
    const timePeriod = `${yearFromData}-${monthNumber}`;

    // Find matching data for the month
    const dataForMonth = inputData?.find(
      (item) => item.timePeriod === timePeriod
    );

    return {
      month: `${abbr}-${shortYear}`, // Always include year
      orderCount: dataForMonth ? dataForMonth?.orderCount : "",
      totalSales: dataForMonth
        ? `₹ ${dataForMonth?.totalSales.toLocaleString("en-IN")}`
        : "",
    };
  });
}

export function transformDateRangeSalesData(inputData) {
  // Array of month abbreviations
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Transform the data
  return inputData?.map((item) => {
    const [year, month] = item?.timePeriod.split("-");

    return {
      month: `${monthNames[parseInt(month) - 1]}-${year.slice(2)}`,
      orderCount: item?.orderCount,
      totalSales: item?.totalSales
        ? `₹ ${item?.totalSales?.toLocaleString("en-IN")}`
        : "",
    };
  });
}


export function transformDateRangeSalesDataByDay(inputData) {
  // Array of month abbreviations
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Transform the data
  return inputData?.map((item) => {
    console.log("item?.timePeriod", item?.timePeriod);
    
    const [year, month, day] = item?.timePeriod.split("-");

    return {
      month: `${day}-${monthNames[parseInt(month) - 1]}-${year.slice(2)}`,
      orderCount: item?.orderCount,
      totalSales: `₹${item?.totalSales.toLocaleString("en-IN")}`,
    };
  });
}

export const formatDaysTimePeriod = (data) => {
  return data.map((item) => ({
    ...item,
    timePeriod: moment(item.timePeriod).format("DD MMM"),
    date: item.timePeriod
  }));
};
